import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Locations } from './pages/Locations';
import { LocationDetail } from './pages/LocationDetail';
import { Therapists } from './pages/Therapists';
import { TherapistDetail } from './pages/TherapistDetail';
import { Services } from './pages/Services';
import { Book } from './pages/Book';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2whx95n6vnccj">
      <ScrollToTop data-id="element-1" data-mp="28ufnm9e7hai0" />
      <div className="flex min-h-screen w-full flex-col bg-ink-950" data-id="element-2" data-mp="28tw3qn4zwc1c">
        <Navbar data-id="element-3" data-mp="28s30zixi6bym" />
        <div className="flex-1" data-id="element-4" data-mp="23vktwcepa1j4">
          <Routes data-id="element-5" data-mp="23ujk0b9f7l2z">
            <Route path="/" element={<Home data-id="element-7" data-mp="23ti5txx3yih1" />} data-id="element-6" data-mp="23v2rsz5cwt3a" />
            <Route path="/locations" element={<Locations data-id="element-9" data-mp="3ij65gd4jrr9g" />} data-id="element-8" data-mp="3ikh829m9asyz" />
            <Route path="/locations/:slug" element={<LocationDetail data-id="element-11" data-mp="3ml1234bj9ggw" />} data-id="element-10" data-mp="3ihv1ac76whht" />
            <Route path="/therapists" element={<Therapists data-id="element-13" data-mp="3mj6jhwnqi0fz" />} data-id="element-12" data-mp="3mjzs7369700r" />
            <Route path="/therapists/:slug" element={<TherapistDetail data-id="element-15" data-mp="3rcsuzli5vya7" />} data-id="element-14" data-mp="3rbrcivytg9ig" />
            <Route path="/services" element={<Services data-id="element-17" data-mp="682dxcgkib2" />} data-id="element-16" data-mp="5yi8qe3h5da" />
            <Route path="/book" element={<Book data-id="element-19" data-mp="7stfczkdj46" />} data-id="element-18" data-mp="5ggxfcks0yi" />
            <Route path="/contact" element={<Contact data-id="element-21" data-mp="2zmeoiach9o8k" />} data-id="element-20" data-mp="2zllff2q1qmn9" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-23" data-mp="33mowttnqsqql" />} data-id="element-22" data-mp="2zn6actg9w7ln" />
          </Routes>
        </div>
        <Footer data-id="element-24" data-mp="33orhrza1ftog" />
      </div>
    </BrowserRouter>;
}